/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * User flows and custom policies for your B2C application
 */
export const b2cPolicies = {
    names: {
        signUpSignIn: '',
        forgotPassword: '',
        editProfile: '',
    },
    authorities: {
        signUpSignIn: {
            authority: '',
        },
        forgotPassword: {
            authority: '',
        },
        editProfile: {
            authority: '',
        },
    },
    authorityDomain: 'cummins365.onmicrosoft.com',
};


/**
 * Configuration object to be passed to MSAL instance on creation. 
 * Full list of MSAL.js configuration parameters:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        tenantId: 'b31a5d86-6dda-4457-85e5-c55bbc07923d',
        clientId: 'df5ceada-83d8-4f3b-9348-578909d1d82f', // This is the ONLY mandatory field that you need to supply.
        // authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
        authority: 'https://login.microsoftonline.com/b31a5d86-6dda-4457-85e5-c55bbc07923d',
        // knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
        redirectUri: '/', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * This is useful if you have a protected web-api in Azure.
 */
export const loginRequest = {};